export default __webpack_public_path__ + "static/media/betShopClient.06ce1f52.svg";